import getConfig from 'next/config';
import type { NextRuntimeConfiguration } from '@hub/libs/config';

const { publicRuntimeConfig } = getConfig() as NextRuntimeConfiguration;

export const FREE_FORM_HUB_URL = 'free-form-hub';
export const SUPPORTED_FREE_FORM_HUB_LOCALES = [
  'en',
  'es',
  'fr',
  'en-GB',
  'en-IE',
  'en-AU',
  'bg-BG',
  'en-CA',
  'en-EE',
  'en-EG',
  'en-FI',
  'en-GR',
  'en-IL',
  'en-IN',
  'en-LT',
  'en-MY',
  'en-NO',
  'en-NZ',
  'sr-RS',
  'en-SG',
  'en-US',
  'en-ZA',
  'es-ES',
  'es-AR',
  'es-CL',
  'es-MX',
  'de-DE',
  'de-AT',
  'de-CH',
  'de-BE',
  'fr-FR',
  'fr-CH',
  'fr-CA',
  'fr-BE',
  'it-IT',
  'it-CH',
  'pl-PL',
  'da-DK',
  'cs-CZ',
  'sk-SK',
  'hu-HU',
  'hr-HR',
  'id-ID',
  'ja-JP',
  'ko-KR',
  'nl-BE',
  'nl-NL',
  'pt-PT',
  'pt-BR',
  'ro-RO',
  'sl-SI',
  'sv-SE',
  'th-TH',
  'tr-TR',
  'vi-VN',
  'zh-TW',
];
export const FFH_SERVICE_INT = publicRuntimeConfig.freeFormHubApiUrl;
export const IFS = { ...publicRuntimeConfig.ifs };
export const NBS = { ...publicRuntimeConfig.nbs };
export const IBD = { ...publicRuntimeConfig.ibd };
export const IGE = { ...publicRuntimeConfig.ige };
export const TRS = { ...publicRuntimeConfig.trs };
export const KOPLA_SERVICES = publicRuntimeConfig.koplaServices;
